import React from 'react';
import './AdminHeader.css';
import {useNavigate} from "react-router-dom";
import axios from "axios";

const AdminHeader = () => {

    const navigate = useNavigate();

    const logout = () => {

        axios.get(`/api/logout/`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    //     'X-CSRFToken': getCookie('csrftoken'),
                    'Access-Control-Allow-Headers': 'X-CSRFToken'
                }, withCredentials: true
            }
        )
            .then(res => {
                navigate('/login');
            })
            .catch(e => {
                console.log(e);
            })

    }

    return (
        <div className={'admin-header'}>
            <div className={'admin-logout-button'} onClick={() => logout()}>Выход</div>
            <p className={'admin-page-title'}>Администратор</p>
        </div>
    );
};

export default AdminHeader;